<div class="form-field">
  <fieldset [class.disabled]="disabled" [class.ng-invalid]="requiredOptions - selectedValues.length > 0">
    <div [style.max-height]="maxHeight" class="multi-select-options">
      <div *ngFor="let option of options; trackBy: trackByValue" class="dropdown-item">
        <label class="custom-checkbox-small" [class.disabled]="isDisabledOption(option.value)" [class.center]="!option.label" style="font-weight:bolder">
          <input type="checkbox"
                 [disabled]="isDisabledOption(option.value)"
                 [name]="option.label"
                 [checked]="isSelected(option.value)"
                 [attr.aria-checked]="isSelected(option.value)"
                 (change)="toggleSelection(option.value)"/>
          <span class="checkmark"></span>
          @if(label){{{ option.label }}}
        </label>
      </div>
    </div>
    <legend>{{ label }}</legend>
  </fieldset>
  @if(requiredOptions > 0 && selectedValues.length < requiredOptions){
  <div class="error">Select at least {{requiredOptions - selectedValues.length}} option{{requiredOptions - selectedValues.length > 1 ? 's' : ''}}</div>
  }
</div>
